import PropTypes from "prop-types";
import React from "react";
import { Button, Dialog, Text } from "@fluentui/react-northstar";

const CommandHelpModal = ({ open, onOpenChange, onClose, sections, header }) => (
  <Dialog
    open={open}
    onOpenChange={onOpenChange}
    onCancel={onClose}
    header={header}
    backdrop
    closeOnOutsideClick
    content={
      <div className="command-log-modal" style={{ maxHeight: 480, overflowY: "auto" }}>
        {sections.length === 0 && (
          <div className="no-commands">
            <Text content="No commands available for this page." />
          </div>
        )}

        {sections.map((section, idx) => (
          <div key={idx} style={{ marginBottom: 16 }}>
            <Text content={section.title} weight="bold" size="large" />
            <div style={{ marginTop: 8 }}>
              {section.items.map((item, j) => (
                <div key={j} className="log-entry success" style={{ padding: 8, borderRadius: 6 }}>
                  <div className="entry-header" style={{ display: "flex", justifyContent: "space-between" }}>
                    <Text content={item.example} size="medium" />
                    {item.description && (
                      <Text content={item.description} size="small" style={{ opacity: 0.8 }} />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    }
    cancelButton={false}
    confirmButton={false}
    footer={
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button content="Close" primary onClick={onClose} />
      </div>
    }
    styles={{ width: "80vw", maxWidth: "700px", maxHeight: "70vh" }}
  />
);

CommandHelpModal.propTypes = {
  header: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          example: PropTypes.string.isRequired,
        })
      ).isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CommandHelpModal;

